export const tokens = {
   neutral: {
      1: 'rgb(255, 255, 255)',
      2: 'rgb(245, 245, 245)',
      3: 'rgb(223, 223, 223)',
      4: 'rgb(204, 204, 204)',
      5: 'rgb(149, 149, 149)',
      6: 'rgb(72, 72, 72)',
      7: 'rgb(17, 17, 17)',
   },

   brand: {
      blue: 'rgb(0, 88, 163)',
      yellow: 'rgb(255, 216, 0)',
   },

   semantic: {
      caution: 'rgb(255, 165, 36)',
      negative: 'rgb(224, 7, 81)',
      positive: 'rgb(10, 138, 0)',
      informative: 'rgb(0, 88, 163)',
      version: 'rgb(74, 144, 226)',
   },

   space: {
      xxs: 'var(--space-xxs)',
      xs: 'var(--space-xs)',
      sm: 'var(--space-sm)',
      md: 'var(--space-md)',
      lg: 'var(--space-lg)',
      xl: 'var(--space-xl)',
      xxl: 'var(--space-xxl)',
      '3xl': 'var(--space-3xl)',
   },

   radius: {
      none: '0',
      sm: '2px',
      md: 'var(--radius-md)',
      lg: 'var(--radius-lg)',
      xl: 'var(--radius-xl)',
      pill: '52px',
   },

   border: {
      thin: '1px solid',
      thick: '2px solid',
   },

   zIndex: {
      base: 100,
      dropdown: 150,
      tooltip: 200,
      overlay: 250,
      sticky: 300,
      modal: 400,
   },

   shadow: {
      xs: '0 1px 2px rgba(17, 17, 17, 0.08)',
      sm: '0 2px 4px rgba(17, 17, 17, 0.1)',
      md: '0 4px 8px rgba(17, 17, 17, 0.15)',
      lg: '0 8px 16px rgba(17, 17, 17, 0.2)',
      xl: '0 20px 60px rgba(17, 17, 17, 0.3)',
   },

   transition: {
      fast: '150ms ease-in-out',
      normal: '250ms ease-in-out',
      slow: '350ms ease-in-out',
   },

   font: {
      family: ['Noto IKEA', 'Noto Sans', 'Roboto', 'Open Sans', 'system-ui', 'sans-serif'].join(','),
      size: {
         xs: '6px',
         sm: '8px',
         md: '10px',
         lg: '12px',
         xl: '16px',
         xxl: '20px',
         '3xl': '24px',
      },
      weight: {
         normal: 400,
         medium: 500,
         semibold: 600,
         bold: 700,
      },
      lineHeight: {
         tight: 'var(--line-height-tight)',
         normal: 'var(--line-height-normal)',
         relaxed: 1.75,
      },
   },

   animation: {
      duration: {
         fast: '150ms',
         normal: '250ms',
         slow: '350ms',
         spinner: '600ms',
         skeleton: '1.5s',
         ellipsis: '600ms',
      },
      easing: {
         standard: 'ease-in-out',
         sharp: 'cubic-bezier(0.4, 0, 0.6, 1)',
         smooth: 'cubic-bezier(0, 1, 1, 0)',
      },
   },
} as const;

export const tokenPxToNumber = (value: string): number => Number.parseFloat(value);
